import { Injectable } from "@angular/core";
import { CategoriesItem, PointOfInterest } from '../../components/categories/categories.model';

export interface NodeServiceModel {
    idCagetory: number;
    idSubCategory: number;
    subCategories: CategoriesItem[];
    idChildCategory: number;
    childCategories: CategoriesItem[];
    idPoi: number;
    pois: PointOfInterest[];
    categories: CategoriesItem[];
    parentSelected: any;
    categoryToEdit: CategoriesItem;
    poiToEdit: PointOfInterest;
    destinationCategory: number;
    poisToMove: number[];
}

@Injectable({
    providedIn: 'root',
})
export class NodeService {

    node: NodeServiceModel = {
        idCagetory: 0,
        idSubCategory: 0,
        subCategories: [],
        idChildCategory: 0,
        childCategories: [],
        idPoi: 0,
        pois: [],
        categories: [],
        parentSelected: null,
        categoryToEdit: {
            id: 0,
            nombre: '',
            fuente: '',
            red: false,
            descripcion: ''
        },
        poiToEdit: {
            id: 0
        },
        destinationCategory: 0,
        poisToMove: []
    }

    setPoisToMove(data: number[]) {
        this.node.poisToMove = data;
    }
        
    getPoisToMove() {
        return this.node.poisToMove;
    }
        
    setDestinationCategory(id: number) {
        this.node.destinationCategory = id;
    }
        
    getDestinantionCategory() {
        return this.node.destinationCategory;
    }

    setPoiToEdit(poi: PointOfInterest) {
        this.node.poiToEdit = poi;
    }

    getPoiToEdit() {
        return this.node.poiToEdit;
    }

    setCategoryToEdit(category: CategoriesItem) {
        this.node.categoryToEdit = category;
    }


    getCategoryToEdit() {
        return this.node.categoryToEdit;
    }  

    setParentSelected(parent: CategoriesItem) {
        this.node.parentSelected = parent;
    }

    getParentSelected(): CategoriesItem {
        return this.node.parentSelected;
    }

    setChildCategories(categories: CategoriesItem[]){
        this.node.childCategories = categories;
    }

    getChildCategories(): CategoriesItem[] {
        return this.node.childCategories;
    }

    setSubCategories(categries: CategoriesItem[]){
        this.node.subCategories = categries;
    }

    getSubCategories(): CategoriesItem[] {
        return this.node.subCategories;
    }
    
    setPois(pois: PointOfInterest[]){
        this.node.pois = pois;
    }

    getPois(): PointOfInterest[] {
        return this.node.pois;
    }

    setCategories(categories: CategoriesItem[]){
        this.node.categories = categories;
    }

    getCategories(): CategoriesItem[] {
        return this.node.categories;
    }

    setCategoryId(idCagetory: number){
        this.node.idCagetory = idCagetory;
    }

    getCategoryId(): number {
        return this.node.idCagetory;
    }

    setSubCategoryId(idSubCategory: number){
        this.node.idSubCategory = idSubCategory;
    }

    getSubCategoryId(): number {
        return this.node.idSubCategory;
    }

    setChildCategoryId(idChildCategory: number){
        this.node.idChildCategory = idChildCategory;
    }

    getChildCategoryId(): number {
        return this.node.idChildCategory;
    }

    setPoiId(idPoi: number){
        this.node.idPoi = idPoi;
    }

    getPoiId(): number {
        return this.node.idPoi;
    }
}